import React from 'react';

import { Modal, Button, Table, TableSelection, TablePagination, Flashbar, Input, Badge } from 'AWS-UI-Components-React';

import { areFieldValuesEquivalent } from '../channel_mapping/channel_mapping_utils';
import { ERROR_MESSAGE } from '../../../constants/views';

const tablePageSize = 10;

export class CMReviewChanges extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedChannelMappings: undefined,

      comment: props.comment,
    };
  }

  getColumnDefinitions = () => {
    return [
      {
        id: 'badge',
        header: 'Status',
        minWidth: '80px',
        cell: (item) => this.renderBadge(item),
      },
      {
        id: 'cognosChannelType',
        header: 'Cognos Channel Type',
        cell: (item) => {
          const isNewCognosType = !Object.keys(this.props.originalChannelMappings || {}).some(id => id.startsWith(item.cognosChannelType + '#'));
          return <span>{this.renderEditableCell(item, 'cognosChannelType', true)} {isNewCognosType && <Badge color="green">New</Badge>}</span>;
        },
      },
      {
        id: 'cognosChannel',
        header: 'Cognos Channel',
        cell: (item) => this.renderEditableCell(item, 'cognosChannel'),
      },
      {
        id: 'channelDescription',
        header: 'Channel Description',
        cell: (item) => this.renderEditableCell(item, 'channelDescription'),
      },
      {
        id: 'cognosParentChannel',
        header: 'Cognos Parent Channel',
        cell: (item) => this.renderEditableCell(item, 'cognosParentChannel'),
      },
      {
        id: 'groupCode',
        header: 'Group Code',
        cell: (item) => this.renderEditableCell(item, 'groupCode'),
      },
      {
        id: 'hcpChannelType',
        header: 'HCP Channel Type',
        cell: (item) => this.renderEditableCell(item, 'hcpChannelType', true),
      },
      {
        id: 'hcpMerchantChannel',
        header: 'HCP Merchant Channel',
        cell: (item) => this.renderEditableCell(item, 'hcpMerchantChannel'),
      },
      {
        id: 'marketplaceId',
        header: 'Marketplace Id',
        cell: (item) => this.renderEditableCell(item, 'marketplaceId'),
      },
      {
        id: 'derivedMarketplaceId',
        header: 'Derived Marketplace Id',
        cell: (item) => this.renderEditableCell(item, 'derivedMarketplaceId'),
      },
      {
        id: 'excluded',
        header: 'Cognos Excluded',
        cell: (item) => this.renderEditableCheckbox(item, 'excluded'),
      },
      {
        id: 'hcpExcluded',
        header: 'HCP Excluded',
        cell: (item) => this.renderEditableCheckbox(item, 'hcpExcluded'),
      },
      {
        id: 'actions',
        header: 'Actions',
        minWidth: '150px',
        cell: (item) => this.renderActions(item),
      },
    ];
  };

  renderBadge = (item) => {
    if (item._deleted || (item.comments && item.comments.startsWith('Deleted by'))) {
      return <Badge color="red">Deleted</Badge>;
    }
    if (item.mappingAdded) {
      return <Badge color="green">New</Badge>;
    }
    return <Badge color="blue">Staged</Badge>;
  };

  renderEditableCell = (item, field, isKeyField = false) => {
    const itemId = item.id || item.cognosChannelType + '#' + item.hcpChannelType + '#*';
    if (item._deleted || (item.comments && item.comments.startsWith('Deleted by'))) return <del style={{ color: '#888' }}>{item[field] || ''}</del>;

    const originalMapping = this.props.originalChannelMappings[itemId];
    const hasChanged = originalMapping && !areFieldValuesEquivalent(originalMapping[field], item[field]);
    const currentVal = item[field] || '';

    // Check if value is new (not in existing dropdown options) for creatable fields
    const creatableFields = ['hcpChannelType'];
    const { dropdownOptions } = this.props;
    const optionsMap = { cognosParentChannel: 'cognosParentChannelOptions', cognosChannel: 'cognosChannelOptions', groupCode: 'groupCodeOptions', hcpChannelType: 'hcpChannelTypeOptions' };
    const isNewValue = creatableFields.includes(field) && currentVal && dropdownOptions &&
      dropdownOptions[optionsMap[field]] && !dropdownOptions[optionsMap[field]].some(o => o.value === currentVal);

    return (
      <div>
        <span>{currentVal}</span>
        {isNewValue && <Badge color="green">New</Badge>}
        {hasChanged && <del style={{ color: '#888', fontSize: '0.85em', display: 'block' }}>{originalMapping[field]}</del>}
      </div>
    );
  };
  renderEditableCheckbox = (item, field) => {
    const isDeleted = item._deleted || (item.comments && item.comments.startsWith('Deleted by'));
    const itemId = item.id || item.cognosChannelType + '#' + item.hcpChannelType + '#*';
    const originalMapping = this.props.originalChannelMappings[itemId];
    const hasChanged = originalMapping && !areFieldValuesEquivalent(originalMapping[field], item[field]);
    const currentVal = Boolean(item[field]) ? 'Yes' : 'No';

    return (
      <div>
        <span>{currentVal}</span>
        {hasChanged && !isDeleted && <del style={{ color: '#888', fontSize: '0.85em', display: 'block' }}>{Boolean(originalMapping[field]) ? 'Yes' : 'No'}</del>}
      </div>
    );
  };

  renderActions = (item) => {
    if (item._deleted || (item.comments && item.comments.startsWith('Deleted by'))) {
      return (
        <Button variant="normal" onClick={() => this.onUndoDelete(item)}>
          Undo Delete
        </Button>
      );
    }

    return (
      <Button variant="normal" onClick={() => this.onRemove(item)}>Remove</Button>
    );
  };

  onRemove = (item) => {
    const itemId = item.id;
    const toUnstage = { [itemId]: item };
    this.props.unstageChannelMappingChanges(toUnstage, this.props.originalChannelMappings);
  };

  onUndoDelete = (item) => {
    const itemId = item.id;
    const oldMapping = {};
    oldMapping[itemId] = item;
    this.props.unstageChannelMappingChanges(oldMapping, this.props.originalChannelMappings);
  };

  getDiffItems = (stagedChannelMappings, modifiedChannelMappingsById, originalChannelMappings) => {
    stagedChannelMappings = stagedChannelMappings ?
                            Object.values(stagedChannelMappings) :
                            Object.values(modifiedChannelMappingsById);
    if (!stagedChannelMappings.length) {
      return [];
    }

    return stagedChannelMappings
      .map((mapping) => {
        const originalMapping = originalChannelMappings[mapping.id];
        return {
          ...mapping,
          mappingAdded: originalMapping === undefined,
          _deleted: mapping._deleted || (mapping.comments && mapping.comments.startsWith('Deleted by')) || false,
        };
      });
  };

  onSelectionChange = (event) => {
    const selectedChannelMappings = event.detail.selectedItems.map((item) => item.id);
    this.setState({ selectedChannelMappings });
  };

  getSelectedCount = (selectedItems) => {
    return selectedItems && selectedItems.length ? <span>({selectedItems.length})</span> : null;
  };

  unstageSelected = (selectedItems) => {
    selectedItems = selectedItems.reduce((obj, item) => ({...obj, [item['id']]: item}), {});
    const { originalChannelMappings, modifiedChannelMappingsById } = this.props;
    const stagedChannelMappings = this.props.stagedChannelMappings ?
                            this.props.stagedChannelMappings :
                            modifiedChannelMappingsById;
    const filterSelected = Object.keys(stagedChannelMappings)
                           .filter(key => Object.keys(selectedItems).includes(key))
                           .reduce((obj, key) => {
                             obj[key] = stagedChannelMappings[key];
                             return obj;
                           }, {});
    if (selectedItems) {
      this.props.unstageChannelMappingChanges(filterSelected, originalChannelMappings);
    }
    this.setState({ selectedChannelMappings: [] });
    // Dismiss modal so it reopens with fresh data after async refresh
    this.onDismiss();
  };

  publishSelected = (selectedItems) => {
    const selectedChannelMappings = selectedItems.reduce((obj, item) => ({...obj, [item['id']]: item}), {});
    const { latestChannelMappingsById, modifiedChannelMappingsById } = this.props;
    const stagedChannelMappings = this.props.stagedChannelMappings ?
                                  this.props.stagedChannelMappings :
                                  modifiedChannelMappingsById;
    const filterSelected = Object.keys(stagedChannelMappings)
                                 .filter(key => Object.keys(selectedChannelMappings).includes(key))
                                 .reduce((obj, key) => {
                                   obj[key] = stagedChannelMappings[key];
                                   return obj;
                                 }, {});
    for (let id of Object.keys(filterSelected)) {
      filterSelected[id] = { ...filterSelected[id], comment: this.state.comment ? this.state.comment : this.props.comment };
    }
    if (selectedChannelMappings) {
      this.props.publishChannelMappingChanges(filterSelected, latestChannelMappingsById);
    }
    this.setState({ selectedChannelMappings: [] });
  };

  onDismiss = () => {
    this.props.onDismiss();
    this.setState({ selectedChannelMappings: undefined });
  };

  onUpdateComment = (event) => {
    this.setState({ comment: event.detail.value });
  };

  render() {
    const {
      visible,
      comment,
      stagedChannelMappings,
      originalChannelMappings,
      modifiedChannelMappingsById,
      expandToFit = true,
      size = 'large',
      errorScreenMessage,
      successScreenMessage
    } = this.props;

    const { selectedChannelMappings } = this.state;

    const diffItems = this.getDiffItems(stagedChannelMappings, modifiedChannelMappingsById, originalChannelMappings);

    

    const selectedItems =
      selectedChannelMappings === undefined
        ? diffItems
        : diffItems.filter((item) => selectedChannelMappings.includes(item.id));

    const content = (
      <div>
        <div className="awsui-util-pt-xs awsui-util-mb-s">
          <Flashbar
            items={
              (selectedItems && selectedItems.find((mapping) => mapping.mappingAdded === true))
                ? [{ type: 'info', content: 'A new mapping will be added' }]
                : []
            }
          />
        </div>
        <Table
          columnDefinitions={this.getColumnDefinitions()}
          items={diffItems}
          empty={'No staged changes.'}
          stickyHeader
        >
          <TableSelection onSelectionChange={this.onSelectionChange} trackBy="id" selectedItems={selectedItems} />
          <TablePagination pageSize={tablePageSize} />
        </Table>
        <h3>Comments:</h3>
        <div>
          <Input value={this.state.comment != null ? this.state.comment : comment} onChange={this.onUpdateComment}/>
        </div>
      </div>
    );

    return (
      <div>
        <Modal
          visible={visible}
          header={'Review/Publish Changes'}
          onDismiss={this.onDismiss}
          expandToFit={expandToFit}
          size={size}
          footer={
            <span className="awsui-util-f-r">
              <Button
                key={'UNSTAGE_SELECTED_BUTTON'}
                variant={'normal'}
                disabled={!this.getSelectedCount(selectedItems)}
                onClick={() => this.unstageSelected(selectedItems)}
              >
                Revert Selected {this.getSelectedCount(selectedItems)}
              </Button>
              <Button
                key={'PUBLISH_SELECTED_BUTTON'}
                variant={'primary'}
                disabled={!this.getSelectedCount(selectedItems)}
                onClick={() => this.publishSelected(selectedItems)}
              >
                Publish Selected {this.getSelectedCount(selectedItems)}
              </Button>
            </span>
          }
        >
          <div>
            <div>
              <Flashbar
                items={
                  errorScreenMessage
                    ? [{ type: 'error', content: `${ERROR_MESSAGE}${errorScreenMessage}`, onDismiss: () => this.setState({ errorScreenMessage: null }) }]
                    : []
                }
              />
            </div>
            <div>
              <Flashbar
                items={
                  successScreenMessage
                  ? [{ type: 'success', dismissible: true, content: `${successScreenMessage}`, onDismiss: () => this.setState({ successScreenMessage: null }) }]
                  : []
                }
              />
            </div>
            {content}
            <div style={{ textAlign: 'center', fontStyle: 'italic' }}>
              <p>Impact of published changes on data will be visible after the next data refresh.</p>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/config_central/channel_mapping/cm_review_changes.jsx